import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API, withCredentials: true });
const refreshClient = axios.create({ baseURL: API, withCredentials: true });
let authFailureHandler = null;

const refreshExcluded = (url = "") => [
  "/auth/login", "/auth/logout", "/auth/refresh",
].some((path) => url.includes(path));

export function setAuthFailureHandler(handler) {
  authFailureHandler = handler;
  return () => {
    if (authFailureHandler === handler) authFailureHandler = null;
  };
}

export function installAuthRefreshInterceptor(apiClient, tokenClient) {
  let refreshPromise = null;
  const refreshAccessToken = () => {
    if (!refreshPromise) {
      refreshPromise = tokenClient.post("/auth/refresh")
        .finally(() => { refreshPromise = null; });
    }
    return refreshPromise;
  };
  const onRejected = async (error) => {
    const original = error?.config;
    if (error?.response?.status !== 401 || !original || original.__authRetried
      || refreshExcluded(original.url)) {
      return Promise.reject(error);
    }
    original.__authRetried = true;
    try {
      await refreshAccessToken();
      return apiClient(original);
    } catch (refreshError) {
      if (refreshError?.response?.status === 401) authFailureHandler?.();
      return Promise.reject(refreshError);
    }
  };
  apiClient.interceptors.response.use((response) => response, onRejected);
  return { refreshAccessToken, onRejected };
}

const authRefresh = installAuthRefreshInterceptor(client, refreshClient);
export const refreshAccessToken = authRefresh.refreshAccessToken;

export function extractError(error, fallback = "Something went wrong. Please try again.") {
  const detail = error?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d.msg || "Please check your input").join(" · ");
  return fallback;
}

export default client;
